import { ComponentTypes } from '@wix/editor-const';
import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { AbstractComponentsPlatformService } from './AbstractComponentsPlatformService';
import { ClientSpecMapService } from '../sharedServices';
import { CacheMethodResponse, MethodCacheStrategy } from '../api';
import { CompRef } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editor-document-logic-api';

export class ApplicationDataPlatformService extends AbstractComponentsPlatformService {
  private readonly clientSpecMapService: ClientSpecMapService;

  constructor(
    ...args: ConstructorParameters<typeof AbstractComponentsPlatformService>
  ) {
    super(...args);
    this.clientSpecMapService = new ClientSpecMapService(
      this.dm,
      this.editorPointerAPI,
    );
  }

  getAppData(editorPointer: EditorPointer<CompRef>) {
    const node = this.virtualElementProvider.buildVirtualElement({
      editorPointers: [editorPointer],
    });

    return this.getAppDataByComponentType(node.getComponentType());
  }

  getAppDataByComponentType(componentType: string) {
    return this.clientSpecMapService.getAppData(componentType);
  }

  getAppComponentDataByComponentType(componentType: string) {
    return this.clientSpecMapService.getAppComponentData(componentType);
  }

  @CacheMethodResponse({
    cacheStrategy: MethodCacheStrategy.Permanent,
  })
  isBuilderComponentType(compType: string) {
    if (
      this.dm.tpa.isTpaByCompType(compType) ||
      compType === ComponentTypes.CustomElement
    ) {
      return true;
    }

    const appComponentData = this.getAppComponentDataByComponentType(compType);

    if (!appComponentData) {
      return false;
    }

    return appComponentData.type === ComponentType.EDITOR_REACT_COMPONENT;
  }
}
